import React from 'react'

const GalleryButton = (props) => {
  return (
    <button onClick={()=>{props.func(props.title)}} className="cursor-pointer mx-1 my-4 lg:my-0 hover:bg-blue-600 border rounded-lg border-x-blue-700 border-y-blue-700 px-3 py-3 font-mono text-xl">
    {props.title}
  </button>
  )
}

export default GalleryButton